import { defineMessages } from 'react-intl';

export default defineMessages({
    modalErrorMessage: {
        id: 'ml.quoteandbind.common.customQuoteComponent.modalErrorMessage',
        defaultMessage: 'Invalid Coverage Option'
    },
    policyTermUnavailableHeaderMessage: {
        id: 'ml.quoteandbind.common.customQuoteComponent.policyTermUnavailableHeaderMessage',
        defaultMessage: 'Invalid Policy Term'
    },
    policyTermUnavailable: {
        id: 'ml.quoteandbind.common.customQuoteComponent.policyTermUnavailable',
        defaultMessage: 'We are not able to offer a 12 month policy term. Please select a 6 month policy term in order to continue.'
    },
    modalErrorDesc: {
        id: 'ml.quoteandbind.common.customQuoteComponent.modalErrorDesc',
        defaultMessage: 'Sorry, but that coverage option is invalid, please select a different value'
    },
    modalInputErrorMessage: {
        id: 'ml.quoteandbind.common.customQuoteComponent.modalInputErrorMessage',
        defaultMessage: 'Invalid input values'
    },
    modalInputErrorDesc: {
        id: 'ml.quoteandbind.common.customQuoteComponent.modalInputErrorDesc',
        defaultMessage: 'Please correct input field errors'
    },
    windstormHailDeductibleBumpedWarning: {
        id: 'ml.quoteandbind.common.customQuoteComponent.WindstormHailDeductibleBumped',
        defaultMessage: 'The Windstorm or Hail Deductible was updated to the minimum required deductible.'
    },
    roofLossSettlementBumpedWarning: {
        id: 'ml.quoteandbind.common.customQuoteComponent.RoofLossSettlementBumped',
        defaultMessage: 'Roof Loss Settlement was updated to Scheduled Roof as required.'
    },
    allOtherPerilBumpedWarning: {
        id: 'ml.quoteandbind.common.customQuoteComponent.AllOtherPerilBumped',
        defaultMessage: 'The All Other Perils deductible was updated to the minimum required deductible.'
    },
    grcAvailableBumpedWarning: {
        id: 'ml.quoteandbind.common.customQuoteComponent.GRCAvailableBumped',
        defaultMessage: 'Blanket Property and/or Guaranteed Rebuild is not available for this risk and the Building Property Loss Settlement and building code coverage have been updated.'
    },
    mvrErrorMessage: {
        id: 'ml.quoteandbind.common.customQuoteComponent.mvrErrorMessage',
        defaultMessage: 'Motor Vehicle Record not available at this time, please try again later.'
    },
    genericErrorMessage: {
        id: 'ml.quoteandbind.common.customQuoteComponent.genericErrorMessage',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    }
});
